import React from 'react';

import FieldList_TableGroup from '../../../components/plain/FieldList_TableGroup';

import { WORK_PLAIN_PATH } from '../../../util/routes';
import { FORM_WORK_TABLE } from '../../../util/consts/forms';

class TabBrWorkLinks extends React.Component {
	
	constructor(props) {
		super(props);
	}
	
	render() {
		let plain = this.props.plain;
		let readOnly = this.props.mode == 'special' || this.props.readOnly;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '20px 20px 20px 20px' }}>
				<FieldList_TableGroup instance={instance} path={'workLink'} parentField={parentField}
					plain={plain} plainDirtyCounter={plain.state.plainDirtyCounter} ignoreTitle={true} 
					readOnly={readOnly}
					table={{
						columns: [
							{ columnId: 'workLinkValue', styles: {tdHeader: {width: '70%'}},
								refNodes: [
									{
										classId: 'Work', plainFormPath: WORK_PLAIN_PATH, 
										selectInstanceFormId: FORM_WORK_TABLE,
										selectInstanceFormTitle: 'Твори'
									}
								]
							},
							{ columnId: 'workLinkIssue', styles: {tdHeader: {width: '30%'}} },
						]
					}}
					styles={{
						table: {width: '100%'},
						trHeader: {height: '33px'}
					}}
				/>
			</div>
		);
	}
}

export default TabBrWorkLinks;